import { IRequestCategory } from "../../../types/category.interface";
import customAxios from "../../customAxios";
import { FIND_CATEGORY } from "../../routes";
// import {ADMIN_ALL_SERVICE} from "../../routes";

const findCategory = async (props: IRequestCategory) => {
  var thisUrl = FIND_CATEGORY + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;
  if (props.type) thisUrl += `&type=${props.type}`;
  if (props.search?.base === "categoryName" && props.search?.value !== "")
    thisUrl += `&categoryName=${props.search?.value}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_CATEGORY: error });
  }
};

export default findCategory;
